// Utility functions for credit input handling
export const normalizeCredit = (value: string): string => {
  // Remove leading zeros and handle empty input
  return value.replace(/^0+/, '') || '0';
};

export const validateAndParseCredit = (value: string): number | null => {
  if (value === '') return null;
  const numericValue = parseInt(normalizeCredit(value), 10);
  return !isNaN(numericValue) ? numericValue : null;
};